import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import { cloneDeep, filter } from "lodash";
import ErrorBoundary from "components/ErrorBoundary";
import SearchInventory from "./components/SearchInventory";
import useAxios from "hooks/useAxios";
import InventoryTable from "./components/InventoryTable";
import {
  onExport,
  getUpdatedFilter,
  getUpdatedFilterLatest,
} from "utils/helper";
import useContextService from "hooks/useContextService";

// let initialFilters = {
//   currentPage: 1,
//   pageSize: 10,
//   orderBy: '',
//   order: '',
//   filters: [],
// };

let filters = [];

let thirdPartyAdminDetails = {};

let filtervalues = {};

const InventorySearch = () => {
  const API = useAxios();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItem, setTotalItem] = useState(0);
  const [collapseSider, setcollapseSider] = useState(false);
  const [columnFilters, setColumnFilters] = useState(null);
  const {
    states: { Inventory },
    setStates,
    resetStates,
  } = useContextService();

  const { search, thirdPartyAdmin, coveredEntity, searchTerms } = Inventory;
  const { tenantID } = thirdPartyAdmin;
  const [state, updateState] = useState({
    data: [],
    coveredEntity: [],
    loading: false,
    selectedEntity: "",
    coveredId: "",
    records: 0,
    reset: false,
  });
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  //   useEffect(() => {
  //     initialFilters = {
  //         currentPage: 1,
  //         pageSize: 10,
  //         orderBy: '',
  //         order: '',
  //         filters: [],
  //     };
  //     setState({ data: [], records: 0 });
  // }, []);

  useEffect(() => {
    if (searchTerms.thirdPartyAdminID) onSearch(searchTerms);
    setColumnFilters(null) ;
  }, []);

  // const onSearch = async (filters) => {
  //   const { coveredEntityID,ndc,pharmacyID,thirdPartyAdminID,thirdPartyAdmin } = filters;
  //   thirdPartyAdminDetails=thirdPartyAdmin;
  //   filtervalues.ThirdPartyAdminID=filters.thirdPartyAdminID;
  //   filtervalues.PharmacyID=filters.pharmacyID;
  //   filtervalues.CoveredEntityID=filters.coveredEntityID;
  //   if (ndc) {
  //     initialFilters.filters = getUpdatedFilter(
  //       'DrugId',
  //       parseInt(ndc),
  //       initialFilters
  //     );
  //   }
  //   else{
  //     initialFilters.filters =[];
  //   }
  //   initialFilters.currentPage = 1;
  //   fetchInventoryData(initialFilters);
  // };

  const onSearch = async (filter) => {
    const {
      coveredEntityID,
      ceIds,
      pharmacyID,
      thirdPartyAdminID,
      pharmacyids,
      DrugId,
      thirdPartyAdmin,
      pharmacyIDS,
      coveredEntityIDS,
      ndc
    } = filter;
    
    thirdPartyAdminDetails = thirdPartyAdmin;

    Object.keys(filter).map((key) => {
      const index = filters.findIndex(
        (item) => item.filterName === key && key != "modifiedDate"
      );
      filters.splice(index, 1);
    });

    if (ndc.id) {
      filters = getUpdatedFilterLatest("DrugId", ndc.id, filters);
    } else {
      Inventory.search.filters = [];
    }

    var phIds = [];
    if (
      pharmacyids != undefined && searchTerms.pharmacyids.length !== undefined && searchTerms.pharmacyids.length > 0) {
      phIds = Array.isArray(filter.pharmacyids)
        ? filter.pharmacyids.map((item) => item["value"])
        : [];
    } else {
      phIds = pharmacyIDS;
    }
    var covids = [];
    if (
      ceIds != undefined &&
      searchTerms.ceIds.length !== undefined &&
      searchTerms.ceIds.length > 0
    ) {
      covids = Array.isArray(filter.ceIds)
        ? filter.ceIds.map((item) => item["value"])
        : [];
    } else {
      covids = coveredEntityIDS;
    }

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    search.filters = filters;
    // search.filters = filters.DrugId;
    search.pharmacyIDS = pharmacyIDS?pharmacyIDS:phIds;
    search.coveredEntityIDS = coveredEntityIDS?coveredEntityIDS:covids;
    searchTerms.currentPage = 1;
    await fetchInventoryData(search);
  };

  const onReset = () => {
    setData([]);
    setTotalItem(0);
    searchTerms.pharmacyids = [];
    // setState({ data: [], reset: !state.reset, records: 0 });
  };

  const fetchInventoryData = async (filters) => {
    setLoading(true);
    if (!tenantID) {
      setLoading(false);
      return null;
    }
     setColumnFilters(filters)
    try {
      const { data, add } = await API.post(
        `/${tenantID}/Inventory/All/${searchTerms.thirdPartyAdminID || 0}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
        setLoading(false);
      } else {
        setData([]);
        setTotalItem(0);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  // const handleExport = async () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/ExportAll/${searchTerms.thirdPartyAdminID}?access_token=${access_token}`;
  //   onExport(action, search);
  // };

  // const slelectedExportcoloumms = async () => {
  //   const { access_token } =
  //     JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/Inventory/SelectedExportAll/${searchTerms.thirdPartyAdminID}?access_token=${access_token}`;
  //   onExport(action, search);
  // };

  
  const slelectedExportcoloumms = async () => {

        let filterObj = columnFilters? columnFilters : search ; 

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = true;

        filterObj.ThirdPartyAdminID =  searchTerms.thirdPartyAdminID || 0; 

    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "inventory";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });

  };


  const handleExport = async () => {

    let filterObj = columnFilters ? columnFilters : search;

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;

    filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;

    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "inventory";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });

  };

  const onPageChange = (filter, haveColFilter) => {
    if (haveColFilter) {
      fetchInventoryData(filter);
    } else {
      fetchInventoryData(filter);
    }
    Inventory.search = { ...Inventory.search, ...filter };
    setStates("Inventory", Inventory);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    filterObj.filters = [...filterObj.filters, ...columnFilters.filters];
    await fetchInventoryData(filterObj);
  };

  const refetch = () => {
    setColumnFilters(null);
    onSearch(searchTerms);
  };

  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  return (
    <div>
       <Container fluid className="width_info">
      <div className={collapseSider ? "mb-0" : "mb-3"}>
        <Card className="border-0 shadow-top">
          <CardBody  hidden={collapseSider} className="">
            <ErrorBoundary>
              <SearchInventory onSearch={onSearch} onReset={onReset} />
              </ErrorBoundary>
          </CardBody>
          </Card>
          </div>
          <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary> 
              <InventoryTable
                tenantID={tenantID}
                data={data}
                // loading={loading}
                AllExport={handleExport}
                slelectedExportcoloumms={slelectedExportcoloumms}
                filters={search}
                totalSize={totalItem}
                onPageChange={onPageChange}
                setLoading={(value) => setState({ loading: value })}
                refetch={refetch}
                onSearchColumnFilters={handleSearchColumnFilters}
                reset={onReset}
                thirdPartyAdmin={thirdPartyAdmin}
                toggleSider={toggleSider}
                collapseSider={collapseSider}
              />
           </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default InventorySearch;
